import { Close, Download } from '@mui/icons-material'
import {
    Box,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material'
interface ResumePreviewDialogProps {
    open: boolean
    onClose: () => void
    url: string | null
    fileName?: string
    loading?: boolean
}

export default function ResumePreviewDialog({
    open,
    onClose,
    url,
    fileName,
    loading,
}: ResumePreviewDialogProps) {
    const handleDownload = () => {
        if (!url) return
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.click()
        link.remove()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{ sx: { height: '90vh', maxWidth: '900px' } }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                }}
            >
                <Typography variant="h6" noWrap sx={{ maxWidth: '70%' }}>
                    {fileName || 'Resume Preview'}
                </Typography>
                <Stack direction="row" spacing={1}>
                    <IconButton
                        size="small"
                        onClick={handleDownload}
                        disabled={!url}
                        title="Download"
                    >
                        <Download fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={onClose} title="Close">
                        <Close fontSize="small" />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent
                sx={{
                    p: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 1,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : url ? (
                    <object
                        data={url}
                        type="application/pdf"
                        style={{ width: '100%', height: '100%', flex: 1 }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: 1,
                                height: '100%',
                            }}
                        >
                            <Typography color="text.secondary">
                                Resume file not found
                            </Typography>
                        </Box>
                    </object>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 1,
                        }}
                    >
                        <Typography color="text.secondary">
                            Unable to load preview
                        </Typography>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export function isPdfDocument(documentKey: string | null | undefined): boolean {
    if (!documentKey) return false
    return documentKey.toLowerCase().endsWith('.pdf')
}
